import * as React from 'react';
import { twMerge } from 'tailwind-merge';
var ResultsCard = function (props) {
    var useDropdownRenderStyling = props.useDropdownRenderStyling, reduceBottomPadding = props.reduceBottomPadding;
    return (React.createElement("div", { className: twMerge('my-5', !!useDropdownRenderStyling && 'm-0') },
        React.createElement("div", { className: twMerge('resultsCard', 'my-8 box-border flex flex-col rounded-2xl border border-solid border-bot-medium-gray bg-white p-8 shadow-results-box-shadow', 'mobile:mt-0 mobile:w-full mobile:pb-0 ', !!useDropdownRenderStyling && 'm-0', !!reduceBottomPadding && 'pb-2') }, props.children)));
};
export default ResultsCard;
